import React, { useCallback } from "react";

import { RouterHook, AppRouter, AppRouterRoutes } from "./router";
import { NotificationContainer } from "./components/notification/NotificationContainer";
import { WithIntl } from "./i18n/withIntl";
import { LoaderContainer } from "./components/loader";
import { ModalHost } from "./components/modal/Modal";
import { ResponsiveContextProvider, sizes } from "./hocs/Responsive";
import { ErrorBoundary } from "./components";

export const App = () => {
  const scrollToTop = useCallback(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ResponsiveContextProvider>
      <WithIntl>
        <AppRouter>
          <ErrorBoundary>
            <RouterHook action={scrollToTop} />
            <NotificationContainer />
            <AppRouterRoutes />
            <ModalHost mobileBreakpoint={sizes.mobileMax} />
          </ErrorBoundary>
          <LoaderContainer />
        </AppRouter>
      </WithIntl>
    </ResponsiveContextProvider>
  );
};
